import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import styled from 'foundations-theming/utils';
import { trellisBreakpoint } from 'pricing-pages-ui-components/constants/Breakpoints';
import ProductIcon from '../../common/ProductIcon';
import { FlushedTitle } from '../SharedComponents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PlanPickerHeaderWrapper = styled.div.withConfig({
  displayName: "PlanPickerHeader__PlanPickerHeaderWrapper"
})({
  [trellisBreakpoint.phone]: {
    flexDirection: 'column',
    alignItems: 'start'
  }
});
const PlanPickerHeader = ({
  productLine,
  id
}) => {
  return /*#__PURE__*/_jsx(PlanPickerHeaderWrapper, {
    children: /*#__PURE__*/_jsx(Flex, {
      alignItems: "end",
      marginBlockEnd: "300",
      id: id,
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        children: [productLine !== 'crmSuite' && /*#__PURE__*/_jsx(ProductIcon, {
          iconStyle: {
            inlineSize: '24px',
            marginInlineEnd: '200',
            marginBlockEnd: '100'
          },
          name: productLine
        }), /*#__PURE__*/_jsx(FlushedTitle, {
          "aria-level": 3,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `planBuilder.plansHeader.${productLine}.largeTitle`
          })
        })]
      })
    })
  });
};
export default PlanPickerHeader;